module.exports = __webpack_public_path__ + "media/images/referrals/cal-icon-74a8f8f355921c4d44c3ac216b7fd399.png";